/* eslint-disable @typescript-eslint/no-use-before-define */
import { Result, ResultsStatus } from '@src/common/types';
import { GraphData, LaFilterPanelState } from '../types';
import { getDefaultGraphData, toEdgeGraphItem } from './getDefaultGraphData';
import { laFetchNodes } from './laFetchNodes';
import { laFetchEdges } from './laFetchEdges';
import { edgesToNodeRequest } from './edgesToNodeRequest';
import { MAX_EDGES_FOR_GRAPH } from './edgeLimits';

export async function laFetchGraph(
  fpState: LaFilterPanelState
): Promise<Result<GraphData>> {
  const {
    edges,
    resultStatus: edgeResultStatus,
    sourceNodeId,
  } = await laFetchEdges(fpState, MAX_EDGES_FOR_GRAPH);

  if (edgeResultStatus !== ResultsStatus.results) {
    return {
      resultStatus: edgeResultStatus,
      result: getDefaultGraphData(),
    };
  }

  const nodeIds = edgesToNodeRequest(edges, sourceNodeId);
  const { result: nodes, resultStatus } = await laFetchNodes({
    nodeIds,
    fpState,
  });

  return {
    resultStatus,
    result: {
      sourceNodeId,
      nodes,
      edges: nodes.length ? edges.map(toEdgeGraphItem) : [],
    },
  };
}
